export enum SlaGseLevel {
  PROCESS = 'PROCESS',
  ACTYPE = 'ACTYPE',
  AIRPORT = 'AIRPORT',
  GSE = 'GSE'
}
